import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { AngularFireModule, FIREBASE_OPTIONS } from '@angular/fire/compat';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { BrowserModule, Meta } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LeafletModule } from '@bluehalo/ngx-leaflet';
import { CommonComponentsModule } from '@suvo-bi-core';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ResponseInterceptor } from './features/interceptors/response.interceptor';
import { PrivateModule } from './features/private/private.module';
import { PublicModule } from './features/public/public.module';
import { IsNavigatingComponent } from './shared/components/is-navigating/is-navigating.component';

@NgModule({
  declarations: [AppComponent, IsNavigatingComponent],
  imports: [
    AngularFireModule,
    BrowserModule,
    BrowserAnimationsModule,
    CommonComponentsModule,
    AppRoutingModule,
    PublicModule,
    PrivateModule,
    MatProgressBarModule,
    LeafletModule,
  ],
  providers: [
    {
      provide: FIREBASE_OPTIONS,
      useValue: {
        authDomain: environment.firebaseAuthDomain,
        apiKey: environment.firebaseApiKey,
      },
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'en-GB',
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ResponseInterceptor,
      multi: true,
    },
    Meta,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
